import React, { PureComponent } from 'react'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import { APP_URL } from '../utils/config.js'
import {
  setAcceptedCordingWarning,
  setCanProceedToNextStep,
  setCordFabricDirection,
  setCordingModalVisible,
  setCordingModalVisibleValue,
  setFabricDirection,
  setSelectedCordFabric,
  setSelectedFabric,
  setSelectedStyle,
} from '../actions/generalActions.js'
import Fabrics from './CushionFabricSelector/Fabrics.js'
import SingleFabric from './CushionFabricSelector/SingleFabric.js'
import FiltersView from './CushionFabricSelector/FiltersView.js'
import _ from 'lodash'
import { BarLoader } from 'react-spinners'
import { capitalizeString, displayToast, getEstimate, scrollTo, sendGtag } from '../utils/utils.js'
import {
  addPreselectedCordedFabric,
  addPreselectedFabric,
  getCordingFabrics,
  getFabrics,
  getFabricsDataByName,
  setColorApiFilters,
  setFrontendFilters,
  setIsOneCustomAttributeAPIFilterApplied,
} from '../actions/fabricsActions.js'
import StepTitle from './StepTitle/index.js'
import CushionCordingWarning from './CushionCordingWarning.js'
import { ReactComponent as OutlinedInfo } from '../../assets/icons/outlined-info.svg'
import NoWelting from '../../assets/style/no-welting.webp'
import SingleCorded from '../../assets/style/single-corded.webp'
import KnifeEdge from '../../assets/style/knife-edge.webp'
import BoxEdge from '../../assets/style/box-edge.webp'
import InfoModal from './Templates/InfoModal'

class CushionStyleSelector extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      currentView: 'fabrics',
    }
  }

  async componentDidMount() {
    const { params, dispatch, general, cushion } = this.props
    const {
      style,
      cordFabricDirection,
      fabricDirection,
      enableScrollTo,
      dimensions,
      acceptedCordingWarning,
    } = general
    let { cordFabric, fabric } = general
    const { styleId, fabricId, fabricDirection: paramsFabricDirection, fabricName } = params.style
    const { id: mainFabricId, direction: mainFabricDirection, name: mainFabricName } = params.fabric
    const { cushionStyles } = cushion

    if (params.category !== '27') {
      if (params?.shape?.id === '859' || params.category === '769' || params.category === '884') {
        if (params?.type?.id !== '11741') {
          if (dimensions.thickness >= 4) {
            dispatch(setSelectedStyle(null))
          }
        }
        if (params?.type?.id === '11786') {
          if (dimensions.seat_thickness < 4) {
            dispatch(setSelectedStyle(null))
          }
        }
      }
    }

    if (!fabric && mainFabricName) {
      const fabricsFromServer = await getFabricsDataByName(
        capitalizeString(mainFabricName?.replaceAll('-', ' ')),
        dispatch,
      )
      fabric = fabricsFromServer?.find((f) => f?.id?.toString() === mainFabricId?.toString())
      if (fabric) {
        dispatch(setSelectedFabric(fabric, acceptedCordingWarning))
        dispatch(addPreselectedFabric(fabric))
        if (mainFabricDirection) {
          dispatch(setFabricDirection(mainFabricDirection))
        }
      }
    }

    const cordFabricName = fabricName || mainFabricName
    const cordFabricId = fabricId || mainFabricId
    if (!cordFabric && cordFabricName) {
      const fabricsFromServer = await getFabricsDataByName(
        capitalizeString(cordFabricName?.replaceAll('-', ' ')),
        dispatch,
      )
      cordFabric = fabricsFromServer?.find((f) => f?.id?.toString() === cordFabricId?.toString())
      if (cordFabric) {
        dispatch(setSelectedCordFabric(cordFabric, acceptedCordingWarning))
        dispatch(addPreselectedCordedFabric(cordFabric))
      }
    }

    const isDirectional =
      cordFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
        ?.options[0] === 'yes'

    if (styleId !== 'style' && fabricId && paramsFabricDirection) {
      let selectedStyle = cushionStyles?.find((style) => style.id.toString() === styleId.toString())
      dispatch(
        setCanProceedToNextStep(!selectedStyle?.name?.includes('Corded') || acceptedCordingWarning),
      )
      dispatch(
        setCordFabricDirection(
          isDirectional
            ? cordFabricDirection || fabricDirection || paramsFabricDirection
            : 'nondirectional',
        ),
      )
    }

    if (style === null) {
      dispatch(setCanProceedToNextStep(false))
    }

    if (style) {
      let selectedStyle = cushionStyles.find((style) => style.id === parseInt(general.style?.id))
      if (params.category !== '27') {
        if (!['734', '735', '736', '29', '859'].includes(params.shape?.id)) {
          // Remove Knife Edge and Single Corded options
          let shapeBlacklist = ['789', '790']
          let cushionStylesCopy = cushionStyles.filter(
            (style) => !shapeBlacklist.includes(style.id.toString()),
          )
          selectedStyle = cushionStylesCopy.find((style) => style.id === parseInt(general.style.id))
        }
      }
      if (selectedStyle) {
        dispatch(setSelectedStyle(selectedStyle))
        if (selectedStyle?.name?.includes('Corded') && !acceptedCordingWarning) {
          dispatch(setCordingModalVisible())
        }
      } else {
        dispatch(setSelectedStyle(null))
        dispatch(setCanProceedToNextStep(false))
      }
    }

    this.removeFilters()

    if (enableScrollTo === true) {
      scrollTo('site-header', 100)
    }

    setTimeout(() => {
      this._getPrice()
    }, 500)

    window.addEventListener('resize', this._checkForMobileLayout)
  }

  componentDidUpdate(prevProps) {
    const { cushion, dispatch, params, history, general } = this.props
    const { general: prevGeneral } = prevProps
    const { cushionStyles } = cushion
    const { acceptedCordingWarning, style } = general
    const { style: prevStyle } = prevGeneral
    const { styleId } = params.style
    if (prevProps.cushion.cushionStyles !== cushionStyles && styleId !== 'style') {
      let selectedStyle = cushionStyles.find((style) => style.id.toString() === styleId.toString())
      if (selectedStyle) {
        dispatch(
          setCanProceedToNextStep(
            !selectedStyle?.name?.includes('Corded') || acceptedCordingWarning,
          ),
        )
      } else {
        history.push(`/cd/${params.category}/type`)
        displayToast(
          'The URL you were trying to access is broken. Please reselect your options',
          'error',
        )
      }
    }

    if (prevProps.cushion.cushionStyles !== cushionStyles) {
      this._onRefresh()
    }

    if (prevStyle?.id !== style?.id) {
      if (style?.name?.includes('Corded') && !acceptedCordingWarning) {
        dispatch(setCordingModalVisible())
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._checkForMobileLayout)
  }

  _checkForMobileLayout = _.debounce(() => {
    // this.setState(prevState => ( { currentView: prevState.currentView === 'filters' ? 'fabrics' : prevState.currentView, } ));
  }, 100)

  removeFilters = () => {
    const { dispatch } = this.props
    const defaultParams = [
      // {
      // 	name: 'stock_status',
      // 	value: 'instock',
      // },
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
    ]
    const defaultParamsForCordings = [
      // {
      // 	name: 'stock_status',
      // 	value: 'instock',
      // },
      {
        name: 'per_page',
        value: '100',
      },
      {
        name: 'page',
        value: '1',
      },
      {
        name: 'cording_in_stock',
        value: '1',
      },
      {
        name: 'orderby',
        value: 'menu_order',
      },
      {
        name: 'order',
        value: 'asc',
      },
    ]

    const defaultFrontendFilters = {
      brand: [0],
      material: [0],
      use: [0],
      pattern: [0],
      colors: [0],
    }
    dispatch(setColorApiFilters([]))
    dispatch(setFrontendFilters(defaultFrontendFilters))
    dispatch(setIsOneCustomAttributeAPIFilterApplied(false))
    dispatch(getFabrics(defaultParams))
    dispatch(getCordingFabrics(defaultParamsForCordings))
  }

  acceptModal = () => {
    const { dispatch } = this.props

    sendGtag('cutting_popup_accept_style')
    dispatch(setAcceptedCordingWarning(true))
    dispatch(setCordingModalVisibleValue(false))
    setTimeout(() => {
      scrollTo('cushion-fabric-selector-container', 100)
    }, 100)
  }

  _toggleModal = () => {
    const { dispatch } = this.props
    dispatch(setCordingModalVisible())
  }

  _selectCushionStyle = (style) => () => {
    const { general, dispatch } = this.props
    dispatch(setSelectedStyle(style))

    if (general?.style?.id !== style?.id) {
      sendGtag('select_style', style?.name)
    }

    // Don't let user proceed yet if style requires a fabric
    // Update: Allow user to proceed even if style requires a fabric
    let canProceed = true

    setTimeout(() => {
      this._getPrice()
    }, 600)
    dispatch(setCanProceedToNextStep(canProceed))
  }

  _onRefresh = () => {
    const { cushion, history } = this.props
    const { cushionStyles } = cushion

    const search = history.location.search

    if (search !== '') {
      const cushionID = search.split('?')[1].split('-')[0]
      const cushionStyle = cushionStyles.find((style) => style.id === parseInt(cushionID))
      this._selectCushionStyle(cushionStyle)()
      this._switchCurrentView()
    }
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    getEstimate(dispatch, general, params)()
  }

  _getStyleImage = (param) => {
    switch (param) {
      case 'single-corded':
        return SingleCorded
      case 'knife-edge':
        return KnifeEdge
      case 'no-welting-box-edge':
        return NoWelting
      case 'box-edge-double-corded':
        return BoxEdge
    }
  }

  _getPillowStyleImage = (param) => {
    try {
      return require(`../../assets/style/pillow/${param}.webp`).default
    } catch (error) {
      console.log('Failed to laod image:', error) //eslint-disable-line
      return ''
    }
  }

  _getCushionStyles = () => {
    const { general, cushion, params, layout } = this.props
    const { style, dimensions, shape, type } = general
    const { currentFlow } = layout
    const { cushionStyles } = cushion
    let cushionStylesCopy = cushionStyles === null ? null : [...cushionStyles]

    if (cushionStylesCopy === null) {
      return <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
    }

    // If shape is anything but square
    if (params.category !== '27') {
      if (
        params?.shape?.id !== '29' ||
        (params?.shape?.id === '29' && parseInt(dimensions.thickness) > 3) ||
        parseInt(dimensions.back_thickness) > 3 ||
        parseInt(dimensions.seat_thickness) > 3
      ) {
        if (
          (params?.shape?.name?.toLowerCase().includes('rectangle') &&
            !params?.shape?.name?.toLowerCase().includes('rounded') &&
            parseInt(dimensions.thickness) < 4) ||
          (shape?.name?.toLowerCase().includes('rectangle') &&
            !params?.shape?.name?.toLowerCase().includes('rounded') &&
            parseInt(dimensions.thickness) < 4)
        ) {
          cushionStylesCopy
        } else if (params?.type?.id === '11786') {
          if (dimensions.seat_thickness < 4) {
            cushionStylesCopy
          } else {
            let shapeBlacklist = ['789', '790']
            cushionStylesCopy = cushionStylesCopy.filter(
              (style) => !shapeBlacklist.includes(style.id.toString()),
            )
          }
        } else if (
          shape?.id === 859 ||
          params?.shape?.id === '859' ||
          params.category === '769' ||
          params.category === '884'
        ) {
          cushionStylesCopy

          if (dimensions.thickness >= 4) {
            let shapeBlacklist = ['789', '790']
            cushionStylesCopy = cushionStylesCopy.filter(
              (style) => !shapeBlacklist.includes(style.id.toString()),
            )
          }
        } else {
          // Remove Knife Edge and Single Corded options
          let shapeBlacklist = ['789', '790']
          cushionStylesCopy = cushionStylesCopy.filter(
            (style) => !shapeBlacklist.includes(style.id.toString()),
          )
        }
      }
    }
    if (params.category !== '27') {
      if (!['734', '735', '736', '29', '859'].includes(params.shape?.id)) {
        // Remove Knife Edge and Single Corded options
        let shapeBlacklist = ['789', '790']
        cushionStylesCopy = cushionStyles.filter(
          (style) => !shapeBlacklist.includes(style.id.toString()),
        )
      }
    }
    // Chair
    if (params.category === '28') {
      // If seat or back is not square
      if (params.shape?.id !== '29' || params.shape?.additionalShapeId !== '29') {
        // Remove Knife Edge
        let shapeBlacklist = ['789']
        cushionStylesCopy = cushionStyles.filter(
          (style) => !shapeBlacklist.includes(style.id.toString()),
        )
      }
    }

    return cushionStylesCopy.map((cushion, index) => {
      return (
        <div
          id={`cushion-style-${index}`}
          key={cushion.id}
          onClick={this._selectCushionStyle(cushion)}
          className={`cushion-style-selector-card ${style?.id === cushion.id ? 'active' : ''}`}
        >
          <div
            className={`cushion-style-selector-card-checkbox ${currentFlow === 'pillow' ? 'cushion-style-selector-card-checkbox-pillow' : ''}`}
          >
            {style?.id === cushion.id && (
              <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
            )}
          </div>
          <div className="style-image-wrapper">
            {currentFlow === 'pillow' ? (
              <img src={this._getPillowStyleImage(cushion.slug)} />
            ) : (
              <img src={this._getStyleImage(cushion.slug)} />
            )}
          </div>
          <div className={'cushion-style-selector-card-text-container'}>
            <div className="card-title">{cushion.name}</div>
            <p>
              {cushion.id === 789 && (type?.id === 11860 || type?.id === 11858 || type?.id === 166)
                ? 'Knife edge pillows are pillows that are made by sewing together the front and back fabric panels to make a more traditional sewing seam.'
                : cushion.id === 790 &&
                    (type?.id === 11860 || type?.id === 11858 || type?.id === 166)
                  ? 'Pillows made with single welting style on the outer edges of the cushion are very similar to knife-edge pillows except that the seam where the front and back panels of the fabric, another small section of fabric is sewn around a thick string or cord and sewn into the seam of the pillow.'
                  : cushion.description}
            </p>
          </div>
        </div>
      )
    })
  }

  _switchCurrentView = (view) => () => {
    this.setState({ currentView: view })
  }

  _getCurrentSubView = () => {
    const { currentView } = this.state
    const { general } = this.props
    const { acceptedCordingWarning } = general

    switch (currentView) {
      case 'fabrics':
        return (
          <div className="style-fabric-wrapper">
            <Fabrics
              switchCurrentView={this._switchCurrentView}
              conditionForProceed={acceptedCordingWarning}
              isStyle
            />
          </div>
        )
      case 'filters':
        return <FiltersView switchCurrentView={this._switchCurrentView('fabrics')} isStyle />
    }
  }

  render() {
    const { currentView } = this.state
    const { general, currentLocationIndex } = this.props
    const { style, cordingModalVisible, acceptedCordingWarning } = general
    const name = general?.type?.name
    const hasSubView = [742, 790].includes(style?.id)

    return (
      <>
        <StepTitle
          name={name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
        />
        {style?.name?.includes('Corded') && currentView !== 'single-fabric' ? (
          <InfoModal
            modalClassName={`cording-modal ${acceptedCordingWarning ? 'warning-accepted' : ''}`}
            isOpen={cordingModalVisible}
            onOpen={this._toggleModal}
            onClose={this._toggleModal}
          >
            <CushionCordingWarning
              acceptModal={this.acceptModal}
              acceptedCordingWarning={acceptedCordingWarning}
            />
          </InfoModal>
        ) : null}
        <div
          className={`cushion-designer-layout ${hasSubView && acceptedCordingWarning ? 'match-content' : ''}`}
        >
          {currentView !== 'single-fabric' && (
            <p className="cushion-designer-footer-text">
              Cushion Pros® is responsible for creating a finished product within a tolerance of
              one-half of an inch (1/2&ldquo;) of the dimensions provided by the customer.
            </p>
          )}
          <div className="style-cards-wrapper">
            {currentView === 'single-fabric' ? (
              <div>
                <SingleFabric
                  switchCurrentView={this._switchCurrentView('fabrics')}
                  isStyle
                  subtitle={
                    <p className="cushion-designer-footer-text">
                      Cushion Pros® is responsible for creating a finished product within a
                      tolerance of one-half of an inch (1/2&ldquo;) of the dimensions provided by
                      the customer.
                    </p>
                  }
                />
              </div>
            ) : (
              <div>
                <div className="cushion-style-selector-wrapper">
                  <div className={'cushion-style-selector'}>{this._getCushionStyles()}</div>
                  <div
                    className={`desktop-warning-wrapper ${cordingModalVisible ? 'warning-open' : ''} ${acceptedCordingWarning ? 'warning-accepted' : ''}`}
                  >
                    {style?.name?.includes('Corded') ? (
                      cordingModalVisible || !acceptedCordingWarning ? (
                        <CushionCordingWarning
                          acceptModal={this.acceptModal}
                          acceptedCordingWarning={acceptedCordingWarning}
                        />
                      ) : (
                        <button
                          type="button"
                          className="desktop-toggle-warning"
                          onClick={this._toggleModal}
                        >
                          <OutlinedInfo width={30} height={30} />
                        </button>
                      )
                    ) : null}
                  </div>
                </div>
                {hasSubView && acceptedCordingWarning && this._getCurrentSubView()}
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  fabrics: state.fabrics,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionStyleSelector))
